import React from "react";
import { MiniChat } from "@griffingroupglobal/lumina-react";
import PropTypes from "prop-types";
import LilyProvider from "../../context/Lily/LilyProvider";
import TopNavBar from "../../stories/Components/NavBar/TopNavBar";
import RouteSidebar from "../../stories/Components/RouteSidebar/RouteSidebar";
import EsModal from "../../stories/Components/EsModal";
import Spinner from "../../stories/Components/Spinner/Spinner";
import EsPopup from "../../stories/Components/EsPopup";
import useMainContainer from "./useMainContainer";
import BreadCrumbs from "./BreadCrumbs/index";
import RouteSwitch from "./RouteSwitch";
import EsSliderPopouts from "./EsSliderPopouts";

const screenCN = "flex flex-col h-screen w-full relative";
const loadingCN = "flex justify-center items-center w-full h-full";
const componentLayerCN =
  "h-full w-full overflow-y-scroll overflow-x-auto bg-es-white py-6 px-8";

const MainContainer = ({ isLoading, isRegistered }) => {
  const {
    location,
    slideOut,
    lilyEnabled,
    toggleSlideOut,
    showMainContent,
    hideNotifications,
    showLoadingSpinner,
    handleMainContainerRef,
  } = useMainContainer({ isRegistered, isLoading });

  return (
    // Screen - Column
    <div className={screenCN}>
      {/* NavBar - full width first in column */}
      <TopNavBar
        hideNotifications={hideNotifications}
        toggleSlideOut={toggleSlideOut}
        slideOut={slideOut}
        isRegistered={isRegistered}
      />

      {showLoadingSpinner && (
        <div className={loadingCN}>
          <Spinner notFullScreen />
        </div>
      )}

      {/* Main Content - Row */}
      {showMainContent && (
        <div className="relative flex flex-row h-full overflow-auto">
          {/* Left Side Navigation - First item in row */}
          <RouteSidebar activeRoute={location.pathname} />
          {/* Container for breadcrumbs and corresponding path component to render */}
          <div
            id="mainContainerScroll"
            className={componentLayerCN}
            ref={handleMainContainerRef}
          >
            <BreadCrumbs />
            <RouteSwitch toggleSlideOut={toggleSlideOut} />
          </div>
        </div>
      )}

      <EsModal />
      <EsPopup />

      {/* Right side Slide outs and Messages */}
      <EsSliderPopouts toggleSlideOut={toggleSlideOut} slideOut={slideOut} />

      {lilyEnabled && (
        <LilyProvider>
          <MiniChat />
        </LilyProvider>
      )}
    </div>
  );
};

MainContainer.propTypes = {
  isLoading: PropTypes.bool,
  isRegistered: PropTypes.bool,
};

MainContainer.defaultProps = {
  isLoading: true,
  isRegistered: false,
};

export default MainContainer;
